/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAppDispatch } from 'Hooks';
import { resetActiveSurvey } from 'store/slices';
import { AppRoutes } from 'Routes/AppRoutes';
import { Location } from 'react-router-dom';

/**
 * Gets the previous route from React Router location state
 * @param location - React Router location object
 * @returns The previous route path or fallback route
 */
export const getPreviousRouteFromLocation = (location: Location): string => {
	return location.state && typeof location.state === 'object' && 'from' in location.state 
		? (location.state as { from: string }).from 
		: AppRoutes.home;
};

/**
 * Custom hook for handling survey exit/close navigation
 * @returns Function to handle survey exit with proper state cleanup
 */
export const useSurveyExit = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const dispatch = useAppDispatch();

	const handleSurveyExit = useCallback((customRoute?: string) => {
		// Determine the route to navigate to
		const routeToNavigate = customRoute || getPreviousRouteFromLocation(location);
		
		// Reset survey state immediately
		dispatch(resetActiveSurvey());
		
		// Navigate to the previous route
		navigate(routeToNavigate);
	}, [navigate, location, dispatch]);

	return handleSurveyExit;
};
